import React from 'react';
import './Banner.css';
import Button from '../../components/ui/Button'; // Reuse the custom Button component
import thumbnailbg from '../../assets/Images/bg/banner3.png'; // Import background image
import { Link } from 'react-router-dom';

interface BannerProps {
  title: string;
  description: string;
  buttonText: string;
}

const Banner: React.FC<BannerProps> = ({ title, description, buttonText }) => {
  return (
    <div
      className="banner"
      style={{ backgroundImage: `url(${thumbnailbg})` }}
    >
      <div className="banner-content">
        <h1 className="banner-title">{title}</h1>
        <p className="banner-description">{description}</p>
       <Link style={{textDecoration:'none'}} to={'/teens'}> <Button variant="white" width="150px">
          {buttonText}
        </Button></Link>
      </div>
    </div>
  );
};

export default Banner;
